export default "__VITE_PUBLIC_ASSET__7e28de07__"